module.exports = __webpack_public_path__ + "static/media/didaima.4a15188.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/didaima.mp4
// module id = IWPp
// module chunks = 0